import {Component, OnInit, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import * as fromProject from '../../../project/reducers';
import {Store} from '@ngrx/store';
import {Subscription} from 'rxjs/Subscription';
import * as ProjectActions from '../../../project/actions/project.actions';


@Component({
  selector: 'multi-language',
  templateUrl: './multi-language.component.html',
  styleUrls: ['./multi-language.component.scss']
})
export class MultiLanguageComponent implements OnInit, OnDestroy {

  // Inputs
  @Input() title: string = 'PROJECT_SETTINGS.MULTI_LANG.TITLE';
  @Input() showLangWarning: boolean = false;
  @Input() languageDropdown: any = {};
  @Input() withAllLanguages: boolean = false;

  // Outputs
  @Output() onLangChange: EventEmitter<any> = new EventEmitter<any>();

  // Public Observables
  public projectLanguageSelected$: Observable<any> = this.projectStore.select(state => state.project.projectLanguageSelected);

  // Public Variables
  public selectedLanguageName: string;
  public selectedLanguage: any = {key: 'en-US', text: 'English'};

  // Subscriptions
  private selectedLanguageSubscription: Subscription;

  // Constructor
  constructor(
    private projectStore: Store<fromProject.State>,
  ) { }

  // On component init
  ngOnInit() {
    this.selectedLanguageSubscription = this.projectLanguageSelected$.subscribe(lang => {
      if (lang) {
        this.selectedLanguage = lang;
        this.selectedLanguageName = lang.text;
        this.onLangChange.emit(lang);
      }
    });
  }

  ngOnDestroy(): void {
    this.selectedLanguageSubscription.unsubscribe();
  }

// On language change
  public onDropdownSelect(value) {
    // this.selectedLanguageName = value.text;
    // this.onLangChange.emit(value);
    this.projectStore.dispatch(new ProjectActions.ChangeProjectLanguageSelected(value));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/multi-language/multi-language.component.ts